<div [formGroup]="form" class="w-full">
    <!-- ===== S7–S8 ===== -->
    <div class="misure-section">
        <div class="misure-section-title">Misure (S7–S8)</div>
        <div class="misure-grid">
            <div *ngFor="let s of sKeys" class="misura-cell">
                <div class="misura-head">
                    <span class="misura-label">{{ s.toUpperCase() }}</span>
                    <span class="misura-ref">rif. {{ normativa?.[s] }}</span>
                </div>
                <div class="misura-input-wrap">
                    <input type="text" inputmode="decimal" [formControlName]="prefix + s" class="misura-input" [ngClass]="getInputRangeClass(s)" />
                    <i class="misura-trend" *ngIf="getTrendIcon(s)" [ngClass]="getTrendIcon(s)"></i>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== P–Q ===== -->
    <div class="misure-section">
        <div class="misure-section-title">Quote (P–Q)</div>
        <div class="misure-grid">
            <div *ngFor="let x of extraKeys" class="misura-cell">
                <div class="misura-head">
                    <span class="misura-label">{{ x.toUpperCase() }}</span>
                    <span class="misura-ref">rif. {{ normativa?.[x] }}</span>
                </div>
                <div class="misura-input-wrap">
                    <input type="text" inputmode="decimal" [formControlName]="prefix + x" class="misura-input" />
                    <i class="misura-trend" *ngIf="getTrendIcon(x)" [ngClass]="getTrendIcon(x)"></i>
                </div>
            </div>
        </div>
    </div>
</div>
